var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "side-file-item",
    attrs: {
      "flat": "",
      "outlined": ""
    }
  }, [_c('v-text-field', _vm._b({
    staticClass: "side-file-item__field",
    attrs: {
      "flat": "",
      "dense": "",
      "solo": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.emit
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [_c('v-checkbox', _vm._b({
          attrs: {
            "color": "primary",
            "hide-details": "",
            "title": "필수여부"
          },
          on: {
            "change": _vm.emit
          },
          model: {
            value: _vm.form.isRequired,
            callback: function ($$v) {
              _vm.$set(_vm.form, "isRequired", $$v);
            },
            expression: "form.isRequired"
          }
        }, 'v-checkbox', _vm.attrs_switch, false))];
      },
      proxy: true
    }, {
      key: "append",
      fn: function () {
        return [_c('v-icon', {
          attrs: {
            "size": "20",
            "color": "black"
          },
          on: {
            "click": _vm.pull
          }
        }, [_vm._v(" mdi-minus ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form.term,
      callback: function ($$v) {
        _vm.$set(_vm.form, "term", $$v);
      },
      expression: "form.term"
    }
  }, 'v-text-field', {
    placeholder: '파일명'
  }, false))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }